import { FC, useMemo } from 'react';
import { useNormalizedModels } from '@common/ui/normalized-model/use-normalized-models';

import { NormalizedModel } from '@player/types';
import { Link } from 'react-router';

import { MoveLeftIcon } from 'lucide-react';
import { Trans } from '@ui/i18n/trans';

import { useCustomStore } from '@player/web-player/state/custom-store';
import clsx from 'clsx';

import { Skeleton } from '@ui/skeleton/skeleton';

export const MobileGenres: FC = () => {
    const { genresMenuOpen, toggleGenresMenuOpen } = useCustomStore();
    const query = useNormalizedModels('normalized-models/genre', {
        perPage: 100,
        // @ts-ignore
        order: 'name:asc',
        minTracks: 150
    })

    const genres = useMemo(() => {
        if (!query.data) return []

        return query?.data?.results as NormalizedModel[]
    }, [query.data?.results])


    return (
        <div
            className={clsx('duration-500 relative pb-[58px]', {
                'animate-in slide-in-from-right': genresMenuOpen,
                'animate-out slide-out-to-right': !genresMenuOpen,
            })}
        >
            <div className="flex h-[58px] absolute bottom-0 border-t bg-alt items-center gap-10 justify-between w-full">
                <button
                    className="px-20 text-xs"
                    onClick={() => toggleGenresMenuOpen?.()}
                >
                    <MoveLeftIcon className="block mx-auto mb-6" />
                    <Trans message="Go back" />
                </button>

                <span
                    className="text-xs rounded-md bg-hover mr-10 py-5 px-10"
                ><Trans message="Genres" /></span>
            </div>

            <div className="h-[calc(100vh-58px)] overflow-y-auto">
                {query.isLoading ? Array.from({ length: 20 }).map((_, index) => (
                    <div key={`loadingGenreMobile_${index}`} className="flex items-center text-sm px-20 py-10 gap-10">
                        <Skeleton
                            variant="text"
                        />
                    </div>
                )) : genres?.map(model => (
                    <Link
                        key={model.id}
                        to={`/genre/${model?.slug || model?.name}`}
                        className="flex items-center text-sm px-20 py-10 gap-10"
                    >
                        {model?.display_name || model?.name}
                    </Link>
                ))}
            </div>
        </div>
    )
}
